import { StyleSheet } from 'react-native';

import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  hintViewStyle: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    height: 48,
  },
  hintIconStyle: {
    marginRight: 21,
  },
  hintTextStyle: theme => ({
    color: theme.colors.text.primary,
    fontFamily: Fonts.type.VFFont,
    fontSize: 16,
  }),
});
